import Session from 'supertokens-auth-react/recipe/session';
import dataProvider from './dataProvider';

const authProvider = {
  login: () => {
    return Promise.resolve();
  },

  logout: async () => {
    await Session.signOut();
    localStorage.clear();
    return '/auth/';
  },

  checkError: async ({ status }) => {
    if (status === 401 || status === 403) {
      await Session.signOut();
      localStorage.clear();
      throw new Error('Session expired');
    }
    return Promise.resolve();
  },

  checkAuth: async () => {
    const sessionExists = await Session.doesSessionExist();
    if (sessionExists) {
      return Promise.resolve();
    }
    throw new Error('Session does not exist');
  },

  getPermissions: async () => {
    // Decide by session, not by URL: the admin uses a HashRouter, so after a
    // bounce to /auth/ the whole app keeps working at /auth/#/... and a
    // pathname check would treat a signed-in SuperAdmin as a guest (hiding
    // every Edit/Create button and the Admins menu).
    const sessionExists = await Session.doesSessionExist();
    if (!sessionExists) {
      if (!window.location.pathname.startsWith('/auth')) {
        // Use window.location instead of redirectToAuth to avoid router context issues
        window.location.href = '/auth/';
      }
      return 'guest';
    }
    if (!localStorage.getItem('user')) {
      try {
        const res = await dataProvider.getOne('users/me', { id: '' });
        const user = res.data;
        if (user.role === 'User') {
          await Session.signOut();
          return 'guest';
        }
        localStorage.setItem('user', JSON.stringify(user));
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        if (error.response?.status === 404) {
          // eslint-disable-next-line no-console
          console.error('User not found in the Praxis database');
        }
        await Session.signOut();
        return 'guest';
      }
    }

    const user = JSON.parse(localStorage.getItem('user'));
    return user && user.role ? user.role : 'guest';
  },

  getIdentity: () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return Promise.resolve({
      id: user.id,
      fullName: user.firstName ? `${user.firstName} ${user.lastName || ''}`.trim() : user.email,
      avatar: user.avatar,
    });
  },
};

export default authProvider;
